import { ExternalLink } from 'lucide-react'
import './ReplayLink.css'

interface ReplayLinkProps {
  replayRecordingId: string | null | undefined
}

export default function ReplayLink({ replayRecordingId }: ReplayLinkProps) {
  if (!replayRecordingId) return null

  const url = `https://app.replay.io/recording/${replayRecordingId}`

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="replay-link"
      data-testid="replay-link"
      data-analytics-event="replay-open-link"
      title={url}
      aria-label={`View Full Recording ${replayRecordingId} (opens in new tab)`}
    >
      <span className="replay-link__lead">
        <ExternalLink size={14} aria-hidden="true" />
        View Full Recording
      </span>
      <span className="replay-link__id">{replayRecordingId}</span>
    </a>
  )
}
